import { useEffect, useState } from "react";
import { Download, ExternalLink, FileText, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const isPreviewableImage = (t) => t?.startsWith("image/") && !t.includes("heic") && !t.includes("heif");

export function FileView({ url, contentType, filename, testid = "file-preview" }) {
  if (isPreviewableImage(contentType)) {
    return (
      <div className="flex items-center justify-center overflow-hidden rounded-xl border border-q-line bg-black/40" data-testid={testid}>
        <img src={url} alt={filename} className="max-h-[420px] w-full object-contain" data-testid={`${testid}-image`} />
      </div>
    );
  }
  return (
    <div className="flex flex-col items-center rounded-xl border border-q-line bg-q-raised/50 p-6 text-center" data-testid={testid}>
      <FileText className="h-10 w-10 text-q-muted" />
      <p className="mt-3 max-w-full break-all text-sm font-semibold text-q-text">{filename}</p>
      <div className="mt-4 flex flex-wrap justify-center gap-2">
        {contentType === "application/pdf" && (
          <button type="button" className="q-btn q-btn-secondary py-2" onClick={() => window.open(url, "_blank")} data-testid={`${testid}-open-btn`}>
            <ExternalLink className="h-4 w-4" /> Open PDF
          </button>
        )}
        <a href={url} download={filename} className="q-btn q-btn-secondary py-2" data-testid={`${testid}-download-btn`}><Download className="h-4 w-4" /> Download</a>
      </div>
    </div>
  );
}

export function StoredFile({ hubId, file }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let u;
    api.get(`/organizations/${hubId}/files/${file.id}`, { responseType: "blob" })
      .then((r) => { u = URL.createObjectURL(r.data); setUrl(u); })
      .catch(() => setError("Couldn't load the file."));
    return () => u && URL.revokeObjectURL(u);
  }, [hubId, file.id]);
  if (error) return <p className="q-error" data-testid="stored-file-error">{error}</p>;
  if (!url) return <div className="flex justify-center py-10"><Loader2 className="h-5 w-5 animate-spin text-q-muted" /></div>;
  return <FileView url={url} contentType={file.content_type} filename={file.filename} testid="bill-file" />;
}
